import * as React from "react";
const SvgShare20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 20,
        fill: "black",
        viewBox: "0 0 21 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M15.914 5.5 10.5.086 5.086 5.5 6.5 6.914l3-3V13.5h2V3.914l3 3L15.914 5.5ZM7.5 8h-5v12h16V8h-5v2h3v8h-12v-8h3V8Z",
      clipRule: "evenodd"
    })
  );
export default SvgShare20Px;
